import type { ReactElement } from 'react';

import { useFeedback } from 'components/technical/Feedback/UseFeedback.tsx';
import ConfirmationDialog from 'components/technical/form/dialog/ConfirmationDialog';
import { useAuth } from '../NewAuthProvider';
import type { MFA_METHOD_ID } from '../amplify-service';

export const DisableMfaDialog = ({ onClose }: { onClose: () => void }): ReactElement => {
  const { showSuccessMessage } = useFeedback();
  const { disableMfaMethod, mfa } = useAuth();

  const disableMfa = async (): Promise<void> => {
    if (!mfa || mfa === 'NO_MFA') {
      showSuccessMessage('Two-factor authentication is already disabled');
      onClose();
      return;
    }

    // Determine which method to disable based on current MFA status
    let methodToDisable: MFA_METHOD_ID = 'totp'; // Default to TOTP
    if (mfa === 'SMS') {
      methodToDisable = 'sms';
    } else if (mfa === 'EMAIL') {
      methodToDisable = 'email';
    }

    await disableMfaMethod(methodToDisable);
    showSuccessMessage('Two-factor authentication was successfully disabled');
    onClose();
  };

  return (
    <ConfirmationDialog
      onClose={onClose}
      onApprove={disableMfa}
      title="Disable two-factor authentication"
      okButtonText="Disable"
      cancelButtonText="Cancel"
    >
      You are about to disable the Two-Factor authentication. Are you sure you want to proceed?
    </ConfirmationDialog>
  );
};
